<!--
배송등록제한 설정 컴포넌트
------------------------------------
-->
<template>
    <!-- 폼 화면 -->
    <div class="uk-flex-top" uk-modal esc-close="false" bg-close="false">
        <div class="uk-modal-dialog uk-margin-auto-vertical uk-width-xxlarge">

            <div class="uk-modal-header">
                <h4 class="uk-text-center">배송등록제한 설정</h4>
            </div>

            <div class="uk-modal-body uk-padding-remove uk-flex uk-flex-between uk-child-width-1-2 uk-flex-top">

                <!-- 정보 표시 -->
                <div class="uk-padding-small" style="border-right: 1px solid #eee">
                    <app-column
                        class="uk-margin-small-bottom"
                        header="닉네임"
                        header-size="medium"
                        body-size="medium"
                        header-align="left"
                        body-align="left"
                        horizontal
                        header-width="80px"
                    >
                        {{ user.nick }}
                    </app-column>

                    <app-column
                        class="uk-margin-small-bottom"
                        header="이메일"
                        header-size="medium"
                        body-size="medium"
                        header-align="left"
                        body-align="left"
                        horizontal
                        header-width="80px"
                    >
                        {{ user.email }}
                    </app-column>

                    <app-column
                        class="uk-margin-small-bottom"
                        header="상호"
                        header-size="medium"
                        body-size="medium"
                        header-align="left"
                        body-align="left"
                        horizontal
                        header-width="80px"
                    >
                        {{ company.name }}
                    </app-column>
                </div>


                <!-- 안내 -->
                <div class="uk-padding-small">
                    해당 회원사의 배송등록을 제한합니다.<br />
                    모든 지역의 배송등록을 할 수 없게됩니다.<br /><br />
                    정말 배송등록을 제한합니까?
                </div>
            </div>


            <div class="uk-modal-footer uk-text-right">

                <!--- 버튼 -->
                <button
                    type="button"
                    class="uk-button uk-button-default uk-modal-close"
                >
                    <span uk-icon="icon: close"></span> 취소
                </button>
                <button
                    type="button"
                    class="uk-button uk-button-danger"
                    v-on:click="submit()"
                >
                    <span uk-icon="icon: check"></span>
                    배송등록제한(완료)
                </button>
            </div>
        </div>
    </div>

</template>

<script>
    export default {
        props: {
            // csrf-token
            csrfToken: String,
        },
        data: function () {
            return {
                // (object) 회원정보
                user: {},

                // (object) 회사정보
                company: {},

                /**
                 * 입력값
                 */
                inputs: {},
            };
        },
        computed: {
        },
        methods: {
            /**
             * 입력폼 display
             */
            displayForm() {

                UIkit.modal(this.$el).show();
            },

            /**
             * 폼
             * @param user_id 회원ID
             */
            form(user_id) {

                // 초기화
                this.inputs = {
                    reason: null,
                };

                // promise 생성
                let load = new Promise((resolve, reject) => {
                    //reject('failed !');

                    // ajax 옵션
                    let opts = {
                        type: 'get',
                        url: '/company-users/' + user_id,
                        contentType: 'application/json',
                        data: {},
                        success: (response, textStatus, jqXHR) => {
                            // promise 성공
                            resolve(response);
                        },
                    };

                    // ajax 실행
                    $.app.ajax.module.background(opts);
                });


                // promise 처리
                load.then((response) => {
                    this.user = response.user;
                    this.company = this.user.company;

                    // 폼띄우기
                    this.displayForm();
                });
            },

            /**
             * submit
             */
            submit() {

                // promise 생성
                let load = new Promise((resolve, reject) => {

                    // ajax 옵션
                    let opts = {
                        type: 'patch',
                        url: '/company-users/' + this.user.id + '/set-restrict-register',
                        data: _.merge({
                            '_token': this.csrfToken,
                        }, this.inputs),
                        success: (response, textStatus, jqXHR) => {
                            // promise 성공
                            resolve(response);
                        },
                    };

                    // ajax 실행
                    $.app.ajax.module.default(opts);
                });

                // promise 처리
                load.then((response) => {
                    UIkit.modal.alert(response.msg).then(() => {
                        $.app.refresh();
                    });
                });
            },

            /**
             * 브라우저 윈도우(탭) 닫기
             */
            closeWindow() {
                window.close();
            },
        },
    }
</script>

<style lang="scss" scoped>
</style>